var _g, _g2, _polyline, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmasungCameraFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M31,1C23.322,1,15.646,3.929,9.788,9.787 C-0.91,20.484-1.841,37.248,6.997,49l6.001,6.002"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M33,63c7.678,0,15.354-2.929,21.212-8.787 C64.91,43.516,65.841,26.752,57.003,15l-6.001-6.002"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "13,44 13,55 2,55  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "51,20 51,9 62,9  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmasungCameraFlip);
export default __webpack_public_path__ + "static/media/smasung_camera_flip.c738d13997dfd13d330eca44f0fb4bbd.svg";
export { ForwardRef as ReactComponent };